
import React from "react";
import type { KcContext } from "./KcContext";
import KcAppImpl from "./KcAppImpl";

export default function KcApp(props: { kcContext: KcContext }) {
  return React.createElement(KcAppImpl, props);
}
